import { render, staticRenderFns } from "./ModalRegraDeCalculoIncluirProcedimentoDescartar.vue?vue&type=template&id=329b0c71&scoped=true"
import script from "./ModalRegraDeCalculoIncluirProcedimentoDescartar.vue?vue&type=script&lang=ts"
export * from "./ModalRegraDeCalculoIncluirProcedimentoDescartar.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegraDeCalculoIncluirProcedimentoDescartar.vue?vue&type=style&index=0&id=329b0c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329b0c71",
  null
  
)

export default component.exports